import React from 'react';
import { Col } from 'react-bootstrap';

type TextHoverListProps = {
  memberStates?: string[];
};

export const TooltipText: React.FC<TextHoverListProps> = ({ memberStates }) => {
  if (!Array.isArray(memberStates) || memberStates.length === 0) return <Col xs={1}></Col>;

  const summary = memberStates
    .slice(0, 3)
    .map((country) => country)
    .join(',');
  const grouped = Array.from({ length: Math.ceil(memberStates.length / 3) }, (_, i) => memberStates.slice(i * 3, i * 3 + 3));

  return (
    <div className="tooltip-container">
      <span className="tooltip-summary-text">
        {summary}
        {memberStates.length > 3 ? '...' : ''}
      </span>
      {memberStates.length > 3 ? (
        <div className="tooltip-text">
          <ul>
            {grouped.map((group, index) => (
              <li key={index}>{group.join(', ')}</li>
            ))}
          </ul>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
